var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgranelLogotype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    height: 40,
    viewBox: "0 0 180 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logotype"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logotype",
    clipPath: "url(#clip-Logotype)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(-60 -44)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Agranel",
    transform: "translate(114 76)",
    fill: "#ff686b",
    fontSize: 32,
    fontFamily: "Muli-Black, Muli",
    fontWeight: 800,
    letterSpacing: "0.008em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Agranel")), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M10,0,20,12H0V-8.23Z",
    transform: "translate(88 84) rotate(-90)",
    fill: "#ffa69e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_82",
    "data-name": "Path 82",
    transform: "translate(60 44)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 34 C 12.28037738800049 34 6 27.7196216583252 6 20 C 6 12.28037738800049 12.28037738800049 6 20 6 C 27.7196216583252 6 34 12.28037738800049 34 20 C 34 27.7196216583252 27.7196216583252 34 20 34 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 12 C 15.58878135681152 12 12 15.58878135681152 12 20 C 12 24.41121864318848 15.58878135681152 28 20 28 C 24.41121864318848 28 28 24.41121864318848 28 20 C 28 15.58878135681152 24.41121864318848 12 20 12 M 20 0 C 31.04569053649902 0 40 8.954309463500977 40 20 C 40 31.04569053649902 31.04569053649902 40 20 40 C 8.954309463500977 40 0 31.04569053649902 0 20 C 0 8.954309463500977 8.954309463500977 0 20 0 Z",
    stroke: "none",
    fill: "#ffa69e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_84",
    "data-name": "Path 84",
    transform: "translate(64 48)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16 2 C 12.26045989990234 2 8.744749069213867 3.456249237060547 6.100500106811523 6.100500106811523 C 3.456249237060547 8.744749069213867 2 12.26045989990234 2 16 C 2 19.73954010009766 3.456249237060547 23.2552490234375 6.100500106811523 25.89949989318848 C 8.744749069213867 28.54375076293945 12.26045989990234 30 16 30 C 19.73954010009766 30 23.2552490234375 28.54375076293945 25.89949989318848 25.89949989318848 C 28.54375076293945 23.2552490234375 30 19.73954010009766 30 16 C 30 12.26045989990234 28.54375076293945 8.744749069213867 25.89949989318848 6.100500106811523 C 23.2552490234375 3.456249237060547 19.73954010009766 2 16 2 M 16 0 C 24.8365592956543 0 32 7.163440704345703 32 16 C 32 24.8365592956543 24.8365592956543 32 16 32 C 7.163440704345703 32 0 24.8365592956543 0 16 C 0 7.163440704345703 7.163440704345703 0 16 0 Z",
    stroke: "none",
    fill: "#ffa69e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_85",
    "data-name": "Path 85",
    transform: "translate(74 58)",
    fill: "#ff686b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 13 C 2.14018988609314 13 -1 9.859809875488281 -1 6 C -1 2.14018988609314 2.14018988609314 -1 6 -1 C 9.859809875488281 -1 13 2.14018988609314 13 6 C 13 9.859809875488281 9.859809875488281 13 6 13 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 0 C 2.68628978729248 0 0 2.68628978729248 0 6 C 0 9.31371021270752 2.68628978729248 12 6 12 C 9.31371021270752 12 12 9.31371021270752 12 6 C 12 2.68628978729248 9.31371021270752 0 6 0 M 6 -2 C 10.41121006011963 -2 14 1.588789939880371 14 6 C 14 10.41121006011963 10.41121006011963 14 6 14 C 1.588789939880371 14 -2 10.41121006011963 -2 6 C -2 1.588789939880371 1.588789939880371 -2 6 -2 Z",
    stroke: "none",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgranelLogotype);
export default __webpack_public_path__ + "static/media/AgranelLogotype.15cf5753192e2f7b07d6b474cf0c6644.svg";
export { ForwardRef as ReactComponent };